import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=5adfafcf&"
import script from "./AppNotifications.vue?vue&type=script&lang=js&"
export * from "./AppNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5adfafcf')) {
      api.createRecord('5adfafcf', component.options)
    } else {
      api.reload('5adfafcf', component.options)
    }
    module.hot.accept("./AppNotifications.vue?vue&type=template&id=5adfafcf&", function () {
      api.rerender('5adfafcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/AppNotifications.vue"
export default component.exports